<template>
  <div class="typing-indicator d-flex align-center pa-2 pl-4">
    <span class="typing-indicator__dot"></span>
    <span class="typing-indicator__dot"></span>
    <span class="typing-indicator__dot"></span>
  </div>
</template>

<script>
export default {
  name: 'ChatTypingIndicator',
};
</script>

<style scoped>
.typing-indicator__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--tc-text-2);
  margin: 0 2px;
  animation: typing-bounce 1.8s infinite ease-in-out;
}

.typing-indicator__dot:nth-child(1) {
  animation-delay: 0s;
}

.typing-indicator__dot:nth-child(2) {
  animation-delay: 0.25s;
}

.typing-indicator__dot:nth-child(3) {
  animation-delay: 0.5s;
}

/* Respiro, nao pulo. O salto de 4px com opacidade indo de 0,4 a 1 puxava o
   olho para os pontos enquanto o que interessa e o texto que vai chegar. O
   curso cai para 2px, a faixa de opacidade encurta e o ciclo abre de 1,4s para
   1,8s: continua legivel como "esta trabalhando", sem competir com a leitura. */
@keyframes typing-bounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.3;
  }
  30% {
    transform: translateY(-2px);
    opacity: 0.75;
  }
}

/* Parada, a fileira continua valendo como indicacao de espera. */
@media (prefers-reduced-motion: reduce) {
  .typing-indicator__dot {
    animation: none;
    opacity: 0.5;
  }
}
</style>
